<div class="row">
  <div class="col-xs-12">
    <h2>Your books</h2>
    <br>
    <p *ngIf="books === undefined">Loading...</p>
    <!-- Ne pas mettre ? à books? met des erreurs temporairement en console en disant que books n'existe pas, que je l'ai initialisé ou non, bizarre -->
    <p *ngIf="books?.length === 0">Your bookshelf is empty at the moment.</p>
    <div class="list-group">
      <button class="list-group-item"
              *ngFor="let book of books; let i = index"
              (click)="onViewBook(i)">
        <h3 class="list-group-item-heading">
          {{ book.title }}
          <!-- J'ajoute une couleur rouge au bouton pour supprimer -->
          <button class="btn btn-default pull-right btn-default" (click)="onDeleteBook(book)">Remove
            <!-- Lui met un signe moins en glyphicon mais je trouve ça moche et pas clair, je préfère mettre un petit texte -->
            <!-- <span class="glyphicon glyphicon-minus"></span> -->
          </button>
        </h3>
        <p class="list-group-item-text">{{ book.author }}</p>
      </button>
    </div>
    <br>
    <button class="btn btn-primary" (click)="onNewBook()">New book</button>
  </div>
</div>